import React, { useState, useRef } from "react";
import "./Intro.scss";
import "../../styles/index.scss";
import { dataIntro } from "../../data/data-intro";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import PropTypes from "prop-types";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import styled from "styled-components";

import SwiperCore, { Navigation } from "swiper";
SwiperCore.use([Navigation]);

import pic1 from "../../assets/images/slider/pic1.jpg";
import pic2 from "../../assets/images/slider/pic2.png";
import pic3 from "../../assets/images/slider/pic3.jpg";
import pic4 from "../../assets/images/slider/pic4.jpg";
import pic5 from "../../assets/images/slider/pic5.jpg";
import pic6 from "../../assets/images/slider/pic6.jpg";
import pic7 from "../../assets/images/slider/pic7.jpg";
import pic8 from "../../assets/images/slider/pic8.jpg";
import pic9 from "../../assets/images/slider/pic9.jpg";
import pic10 from "../../assets/images/slider/pic10.jpg";
import pic11 from "../../assets/images/slider/pic11.jpg";
import pic12 from "../../assets/images/slider/pic12.jpg";
import pic13 from "../../assets/images/slider/pic13.jpg";
import pic14 from "../../assets/images/slider/pic14.jpg";

import imgBrush from "../../assets/images/intro/brush-after.png";
import imgBrushLarge from "../../assets/images/intro/brush-after-large.png";

const StyledImagActive = styled.img`
  border: ${(props) => (props.active ? "2px solid #3aacf2" : "unset")};
  transition: all 0.2s ease-in-out 0s;
  &:hover {
    transform: translate3d(0, -5px, 0);
    opacity: 0.7;
    -webkit-transform: translate3d(0, -5px, 0);
  }
`;

const StyledSwiper = styled(Swiper)`
  height: fit-content;
  padding-bottom: 60px;
  border-radius: 30px;
`;

const StyledImageThumb = styled.img`
  width: 100vh;
  border-radius: 30px;
`;

StyledImagActive.propTypes = {
  active: PropTypes.bool.isRequired,
};

const SUB_SLIDES_PER_VIEW = 11;
const SUB_SLIDES_PER_VIEW_RESPONSIVE = 8;
const SUB_SLIDES_PER_VIEW_RESPONSIVE_2 = 9;
const MAIN_SLIDES_PER_VIEW = 1;
const IntroPageMobile = (props) => {
  const array = [
    pic1,
    pic2,
    pic3,
    pic4,
    pic5,
    pic6,
    pic7,
    pic8,
    pic9,
    pic10,
    pic11,
    pic12,
    pic13,
    pic14,
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [subCurrentSlide, setSubCurrentSlide] = useState(0);
  const useRefArrowRight = useRef(null)
  const [sliderRef, slider] = useKeenSlider({
    slidesPerView: MAIN_SLIDES_PER_VIEW,
    initial: 0,
    loop: true,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
      subSlider &&
        subSlider.moveToSlideRelative(s.details().relativeSlide, true, 500);
    },
  });


  const ArrowRight = ({ onClick, ref }) => {
    return <div onClick={onClick} className={"arrow arrow--right"} ref={useRefArrowRight} />;
  };


  // useEffect(() => {
  //   if (currentSlide === 7 || currentSlide === 13) {
  //     subSlider.moveToSlideRelative(subCurrentSlide + 7, true, 500);
  //   }
  // }, [currentSlide])

  const [subSliderRef, subSlider] = useKeenSlider({
    slidesPerView: SUB_SLIDES_PER_VIEW,
    initial: 0,
    spacing: 15,
    loop: true,
    breakpoints: {
      "(min-width: 768px) and (max-width: 1200px)": {
        slidesPerView: SUB_SLIDES_PER_VIEW_RESPONSIVE,
      },
      "(min-width: 1200px) and (max-width: 1400px)": {
        slidesPerView: SUB_SLIDES_PER_VIEW_RESPONSIVE_2,
      },
    },
    slideChanged(s) {
      setSubCurrentSlide(s.details().relativeSlide);
    },
    move(s) {
      const new_opacities = s.details().positions.map((slide) => slide.portion);
      setOpacities(new_opacities);
    },
  });


  const renderSliders = (images) =>
    images.map((image, index) => (
      <div
        key={`keen-slider${index}`}
        className={`keen-slider__slide number-slide${index} 
        ${currentSlide === index ? "activeSlider" : "unActiveSlider"
          }`}
      >
        <StyledImageThumb
          src={image}
          alt="product"
          style={{ objectFit: "scale-down" }}
        />
      </div>
    ));
  const [opacities, setOpacities] = React.useState([]);

  const handleClickSubSlider = (index) => (e) => {
    slider.moveToSlide(index);
    // subSlider.moveToSlide(index);
  };
  const renderSubSliders = (images, activeIndex = -1) => {
    return images.map((image, index) => (
      <div
        style={{ opacity: opacities[index] }}
        key={`sub-slider${index}`}
        className={`keen-slider__slide number-slide${index}`}
        onClick={handleClickSubSlider(index)}
      >
        <StyledImagActive
          src={image}
          alt="product"
          active={activeIndex === index}
        />
      </div>
    ));
  };

  const handleClickArrowMainSlider =
    (isNext = true) =>
      (e) => {
        if (isNext) {
          e.stopPropagation() || slider.next();
          subSlider.moveToSlide(currentSlide + 1);
          setSubCurrentSlide(currentSlide + 1);
        } else {
          e.stopPropagation() || slider.prev();
          subSlider.moveToSlide(currentSlide - 1);
          setSubCurrentSlide(currentSlide - 1);
        }
      };
  const handleClickArrowSubSlider =
    (isNext = true) =>
      (e) => {
        if (isNext) {
          e.stopPropagation() ||
            subSlider.moveToSlideRelative(subCurrentSlide + 2, true, 500);
        } else {
          e.stopPropagation() || subSlider.moveToSlide(subCurrentSlide - 2, 500);
        }
      };

  const sliderContent = (arrayItem) => (
    <>
      <div className="introNP-large-content">
        <div className="container" >
          <div className="introNP-large-left" >
            <div className="introNP-mobile-title-desktop">
              {dataIntro.title2}
            </div>
            <p style={{ paddingBottom: 30 }}>{dataIntro.content2}</p>
            <p>{dataIntro.content3}</p>
          </div>
          <div className="introNP-large-right">
            <div className="navigation-wrapper">
              <div className="navigation-wrapper__content">
                <div ref={sliderRef} className="keen-slider">
                  {renderSliders(arrayItem)}
                </div>
              </div>
              {slider && (
                <>
                  <ArrowLeftDesktop
                    onClick={handleClickArrowMainSlider(false)}
                  />
                  <ArrowRightDesktop onClick={handleClickArrowMainSlider()} />
                </>
              )}
              <div className="introNP-large-right-brush">
                <img loading="lazy" src={imgBrushLarge} alt="brush" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="introNP-mobile-slider-mini">
        <div className="container">
          <div className="introNP-large__subitems">
            <div className="subitems">
              <div ref={subSliderRef} className="keen-slider">
                {renderSubSliders(arrayItem, currentSlide)}
              </div>

              {subSlider && (
                <>
                  <ArrowLeft onClick={handleClickArrowSubSlider(false)} />
                  <ArrowRight onClick={handleClickArrowSubSlider()} />
                  <div className="bgTransitions" />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
  return (
    <>
      <div className="introNP-mobile">
        <div className="container">
          <div className="introNP-mobile-title">{dataIntro.title}</div>
          <p style={{ paddingBottom: 20 }}>{dataIntro.content2}</p>
          <p>{dataIntro.content3}</p>
        </div>
        <div className="introNP-mobile-slider container">
          <StyledSwiper loop={true} navigation={true} className="mySwiper">
            {array.map((value, index) => (
              <SwiperSlide key={index}>
                <img loading="lazy" src={value} alt="img" key={index} style={{ objectFit: 'contain' }} />
              </SwiperSlide>
            ))}
          </StyledSwiper>
        </div>
        <div className="introNP-mobile-slider-brush">
          <StyledImageThumb src={imgBrush} alt="brush" key="brush" />
        </div>
      </div>
      <div className="introNP-large">

        {sliderContent(array)}
      </div>
    </>
  );
};

const ArrowLeft = ({ onClick }) => {
  return <div onClick={onClick} className={"arrow arrow--left"} />;
};


const ArrowLeftDesktop = ({ onClick }) => {
  return <div onClick={onClick} className={"arrow arrow--left--desktop"} />;
};

const ArrowRightDesktop = ({ onClick }) => {
  return <div onClick={onClick} className={"arrow arrow--right--desktop"} />;
};

export default React.memo(IntroPageMobile);
